import React, { useEffect, useState } from 'react';
import { TextField } from 'material-ui';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import './HSIdsCodes.scss';

/**
 * Change customer id for one cargo inside cargo request
 * @param {{ 
 *  clientRefNo: string | undefined,
 *  cargoOrder: any, 
 *  changeCargo: Function }} value
 */
function CargoReferences({ 
    cargoOrder, clientRefNo, changeCargo,
}) {
    const [value, setValue] = useState(clientRefNo || undefined);
    
    useEffect(() => {
        if (cargoOrder) {
            changeCargo([{
                field: 'clientRefNo',
                value: value || undefined,
            }]);
        }
    }, [value]);

    return (
        <div 
            id='customer-id'
            className='row'
        >
            <div className='column-left'>
                Cargo reference(s):
            </div>
            <div className='column-right'>
                <TextField
                    className='cargoReferences_value'
                    value={value || ''}
                    hintText='Cargo reference(s)'
                    hintStyle={{ fontSize: '13px' }}
                    style={{ fontSize: '13px' }}
                    onChange={e => setValue(e.target.value)}
                />
            </div>
        </div>
    );
}

CargoReferences.propTypes = {
    cargoOrder: PropTypes.any,
};

CargoReferences.defaultProps = {
    cargoOrder: undefined,
};

export default React.memo(connect(
    (state, ownProps) => {
        const cargoOrder = state.cargoOrders.items[ownProps.numberOrderTable];
        return {
            cargoOrder,
        };
    },
    null,
)(CargoReferences));



// WEBPACK FOOTER //
// ./app/components/Letters/SingleNew/Cargo/Sidebar/Order/HSIdsCodes/CargoReferences.jsx